
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import DiscountCouponInputBar from "./DiscountCouponInputBar";
import CollectionList from "../../widgets/CollectionList";
import CouponsListItem from "./CouponsListItem";
import { ReloadSvg, NewListSvg, ListCheckSvg, ListMinusSvg, DeleteSvg } from "../../icons/Icon";
import { getAllDiscount, storeAllDiscount } from "../../api/actions/actions";
import { useEventContext } from "../../contexts/EventContextProvider";
import {
    createDiscountFormEvent,
    setSelectedDiscountEvent,
    deleteSelectedDiscountEvent,
    fetchAllDiscountsEvent
} from "../../events/DiscountEvents";

const CustomActions = (p) => {

    const { state, eventDispatch } = useEventContext();
    const discounts = useSelector((state) => state.base.discounts);
    const dispatch = useDispatch();

    const onNew = (e) => {
        eventDispatch(createDiscountFormEvent());
    };
    const onReload = () => {
        fetchAllDiscountsEvent(true);
    };
    const onCheckAll = () => {
        var all = discounts.reduce((accumulator, discount) => {
            accumulator[discount.id] = true;
            return accumulator;
        }, {});
        eventDispatch(setSelectedDiscountEvent(all, p.listRef));
    };
    const onUncheckAll = () => {
        eventDispatch(setSelectedDiscountEvent({}, p.listRef));
    }
    const onDeleteAllSelected = () => {
        //console.log('onDeleteAllSelected', state.selectedDiscounts);
        eventDispatch(deleteSelectedDiscountEvent(state.selectedDiscounts));
    };
    return (
        <div className="CollectionList_actions">
            <button className="CollectionList_reload" onClick={onReload}><ReloadSvg /></button>
            <button className="CollectionList_new" onClick={onNew}><NewListSvg /></button>
            <button className="CollectionList_RemoveFromAll" onClick={onDeleteAllSelected}><DeleteSvg /></button>
            <button className="CollectionList_CheckAll" onClick={onCheckAll}><ListCheckSvg /></button>
            <button className="CollectionList_UncheckAll" onClick={onUncheckAll}><ListMinusSvg /></button>
        </div >
    );
}
const Coupons = () => {

    const inputBar = useRef(null);
    const list = useRef(null);
    const discounts = useSelector((state) => state.base.discounts);
    const { state, eventDispatch } = useEventContext();
    const onSelect = (selected) => eventDispatch(setSelectedDiscountEvent(selected));

    useEffect(() => {
        fetchAllDiscountsEvent();
    }, []);

    return (
        <div className="page">
            <div className="flex-24">
                <div className="col-24 flex-column">
                    <div className="page-box">
                        <div className='page-box-header'>
                            <h4><span>Create coupons</span></h4>
                        </div>
                        <div className='page-box-body'>
                            <DiscountCouponInputBar ref={inputBar} />
                            <CollectionList
                                ref={list}

                                selectable={true}
                                onSelect={onSelect}
                                itemsPerPage={10}
                                items={discounts}

                                ItemsComponent={CouponsListItem}
                                CustomActionsComponent={(p) => <CustomActions listRef={list.current} />}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Coupons;